const responsible = {
  "Admin": {
    actions: []
  },
  "Content": {
    actions: []
  },
  "Dashboard": {
    actions: ['view']
  },
  "Help": {
    actions: []
  },
  "Inbox": {
    actions: []
  },
  "Notifications": {
    actions: ['view']
  },
  "Objects": {
    actions: []
  },
  "Search": {
    actions: []
  },
  "Settings": {
    actions: []
  },
  "Support": {
    actions: []
  },
  "Tasks": {
    actions: []
  },
  "Teams": {
    actions: []
  },

  "Profile.PersonalInformation": {
    actions: ['view', 'edit']
  },
  "Profile.Password": {
    actions: ['view', 'edit']
  },
  "Profile.Notifications": {
    actions: []
  },
  "Profile.Security": {
    actions: []
  },
  "Profile.Log": {
    actions: []
  },
  "Modules.Customer": {
    actions: ["view"]
  },
  "Modules.Customer.Contacts": {
    actions: ["view"]
  },
  "Modules.Customer.Comments": {
    actions: ["view"]
  },
  "Modules.Customer.Address": {
    actions: ["view"]
  },
  "Modules.Customer.Responsibles": {
    actions: ["view"]
  },
  "Modules.Customer.Station": {
    actions: ["view"]
  },
  "Modules.Customer.TechnicalInformation": {
    actions: ['view']
  },
  "Modules.Gps": {
    actions: []
  },
  "Modules.Inspection": {
    actions: []
  },
  "Modules.PeriodicCheck": {
    actions: ["view", "edit:own", "create"]
  },
  "Modules.Responsible": {
    actions: []
  },
  'Modules.Responsible.Comments': {
    actions: []
  },
  'Modules.Responsible.Contacts': {
    actions: []
  },
  'Modules.Responsible.Information': {
    actions: []
  },
  'Modules.Support': {
    actions: []
  },
  'MainMenu.WorkManagement': {
    actions: ['view']
  },
  'MainMenu.Home': {
    actions: ['view']
  },
  'MainMenu.Notifications': {
    actions: ['view']
  },
  'MainMenu.Inbox': {
    actions: []
  },
  'MainMenu.Tasks': {
    actions: []
  },
  'MainMenu.Support': {
    actions: []
  },
  'SubMenu.Help': {
    actions: []
  },
  'SubMenu.Search': {
    actions: []
  },
  'ProfileMenu.MyProfile': {
    actions: ['view']
  },
  'ProfileMenu.Admin': {
    actions: []
  },
  'ProfileMenu.Content': {
    actions: []
  },
  'ProfileMenu.Objects': {
    actions: []
  },
  'ProfileMenu.Teams': {
    actions: []
  },
  'ProfileMenu.SignOut': {
    actions: ['view']
  },
  'AdminMenu.General': {
    actions: []
  },
  'AdminMenu.Customization': {
    actions: []
  },
  'AdminMenu.User': {
    actions: []
  },
  'AdminMenu.Security': {
    actions: []
  },
  'AdminMenu.Permissions': {
    actions: []
  },
  'AdminMenu.Database': {
    actions: []
  },
  'AdminMenu.Reports': {
    actions: []
  },
  'AdminMenu.Enargas': {
    actions: []
  },
  'CustomerMenu.Download': {
    actions: []
  },
}

export default responsible